import PropTypes from 'prop-types';
import React from 'react';
import { Field } from 'redux-form';
import Button from '../../elements/Button';
import styles from './styles.scoped.css';
import { fieldsProps } from './schema';
import { passwordStrength } from '../../../utils/validation';
import { useSelector } from 'react-redux';
import Password from '../../fields/Password';
import PasswordStrength from '../../elements/PasswordStrength';

export default function ChangeUserPasswordForm({
  // change = () => {},
  handleSubmit = () => {},
  invalid = true,
  // isLoading = false,
  message = '',
}) {
  const { values } = useSelector((state) => state.form.changeUserPasswordForm);
  const { loading } = useSelector((state) => state.user);
  const strengthScore = passwordStrength(values.password);

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit(values);
  };

  return (
    <form className={styles.form} onSubmit={onSubmit}>
      {message ? <p className={styles.error}>{message}</p> : null}
      <Field
        component={Password}
        inputProps={fieldsProps.password}
        name="password"
      />
      <PasswordStrength score={strengthScore} />
      <div className={styles.description}>
        <p>{fieldsProps.password.description}</p>
      </div>
      <Field
        component={Password}
        inputProps={fieldsProps.confirmPassword}
        name="confirmPassword"
      />
      <Button
        disabled={invalid || loading}
        eventName="changeUserPasswordForm"
        fullWidth
        type="submit"
      >
        Simpan
      </Button>
    </form>
  );
}

ChangeUserPasswordForm.propTypes = {
  change: PropTypes.func,
  handleSubmit: PropTypes.func,
  invalid: PropTypes.bool,
  isLoading: PropTypes.bool,
  message: PropTypes.string,
};
